import * as React from 'react';
import { SettingsApplication } from '../../model'
import { SettingsService } from '../../../../util/SettingsService';
import { CloudHubStatus, SettingsCategory } from '../../../../util/SettingsConfigurations'
import { getAppStatus } from './SettingsBodyResourcesListBody'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon';
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox';
import Button from '@mulesoft/anypoint-components/lib/Button';
import Spinner from '@mulesoft/anypoint-components/lib/Spinner';
import '../SettingsBodyResourcesList.css'

export type ValueProps = {
  app: SettingsApplication
}

export type EventProps = {
  onEnableCheckbox?: (id: string) => void
  onApply?: (amEnabled: boolean, app: SettingsApplication) => void
}

export type Props = ValueProps & EventProps

const isProgressStatus = (status: string) => {
  return status === CloudHubStatus.deploying || status === CloudHubStatus.undeploying
}

const getMonitoringCheckboxStatus = (status: string) => {
  return isProgressStatus(status) ? 'settings-body-resources-list-monitoring-enabling-check progress-status' :
                                    'settings-body-resources-list-monitoring-enabling-check'
}

export const MonitoringCheckbox = (props: Props) => {
  const {app, onEnableCheckbox} = props
  const status = getAppStatus(app.status, app.deploymentUpdateStatus)
  const amEnabled = app.type === SettingsCategory.RTF ? true : SettingsService.isApplicationEnabled(app)
  const onEnableCheckboxFunction = onEnableCheckbox ? () => onEnableCheckbox(app.name) : undefined
  
  return (
    <div className={getMonitoringCheckboxStatus(status)}>
      {
        amEnabled ? <IconPanel className={`${app.name}-icon`} testId={`${app.name}-icon`} name="check-small" fill="#17bc65" size={20}/> :
          <Checkbox
            className={`${app.name}-checkbox`}
            testId={`${app.name}-checkbox`}
            onChange={onEnableCheckboxFunction}
            checked={app.monitoringChecked}
            disabled={isProgressStatus(status)}
          />}
      <span
        data-test-id={`${app.name}-is-enabled-text`}
        className={`${amEnabled ? 'enabled-text' : 'enable-text'}`}
      >
        {amEnabled ? 'Enabled' : 'Enable'}
      </span>
    </div>
  )
}

const getMonitoringButtonText = (status: string, amEnabled: boolean) => {
  return isProgressStatus(status) ? 'Applying' : amEnabled ? 'Disable' : 'Apply'
}

export const SettingsBodyResourcesListBodyMonitoring = (props: Props) => {
  const {app, onApply} = props
  const status = getAppStatus(app.status, app.deploymentUpdateStatus)
  const amEnabled = app.type === SettingsCategory.RTF ? true : SettingsService.isApplicationEnabled(app)
  const onApplyFunction = onApply ? () => onApply(amEnabled, app) : undefined
  
  return (
    <div className={`${app.name} settings-body-resources-list-monitoring-enabling ${isProgressStatus(status) ? 'progress-status' : ''}`}>
      <MonitoringCheckbox {...props}/>
      {
        app.muleVersion && !SettingsService.isAMVersion(app.muleVersion.version) &&
        <Button
          className={`${app.name}-button`}
          testId={`${app.name}-button`}
          onClick={onApplyFunction}
          kind={amEnabled ? 'tertiary' : 'primary'}
          disabled={amEnabled && !isProgressStatus(status) ? false : (!app.monitoringChecked || isProgressStatus(status))}
        >
          <span
            data-test-id={`${app.name}-button-text`}
            className={'settings-body-resources-list-monitoring-enabling-button-text'}
          >
              {getMonitoringButtonText(status, amEnabled)}
          </span>
          {(status === CloudHubStatus.deploying  || status === CloudHubStatus.undeploying)
          && <Spinner className="settings-body-resources-list-monitoring-enabling-spinner" size="s"/>}
        </Button>
      }
    </div>
  )
}
